p {
    font: var(--paragraph-typography);
    margin-bottom: var(--paragraph-margin-bottom);

    &.neutral {
        color: var(--color-neutral-standalone-text);
     }

     &.information {
        color: var(--color-info-standalone-text);
      }

      &.success {
        color: var(--color-success-standalone-text);
       }

      &.danger {
        color: var(--color-danger-standalone-text)
       }
}